export default "__VITE_ASSET__25bc00b6__"